var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.iconMap[_vm.type])?_c('i',{staticClass:"dol-icon",class:'dol-icon-' + _vm.type},[_c('dol-icon-' + _vm.type,{tag:"component"})],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }